module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('h1', {
    staticClass: "display-4"
  }, [_vm._v(_vm._s(_vm.$t('item.list')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 d-flex align-items-center justify-content-end"
  }, [_c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-secondary",
      "title": "Terug",
      "exact": "",
      "to": {
        name: 'Landingpage'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-reply"
  })])], 1)]), _vm._v(" "), (_vm.error) ? _c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": ""
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "my-1 row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('filter-options', {
    attrs: {
      "item": "",
      "person": ""
    },
    on: {
      "input": _vm.filterData
    },
    model: {
      value: (_vm.filterObj),
      callback: function($$v) {
        _vm.filterObj = $$v
      },
      expression: "filterObj"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 d-flex justify-content-end"
  }, [_c('b-pagination-nav', {
    staticClass: "pull-right",
    attrs: {
      "link-gen": _vm.linkGen,
      "number-of-pages": _vm.items.last_page,
      "value": _vm.items.current_page,
      "use-router": ""
    }
  })], 1)]), _vm._v(" "), _c('partial-loader', {
    attrs: {
      "loading": _vm.isFetching
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [(!_vm.isFetching) ? _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "show-empty": "",
      "items": _vm.items.data,
      "fields": _vm.fields,
      "per-page": parseInt(_vm.items.per_page),
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "no-local-sorting": true,
      "empty-text": _vm.$t('item.listEmptyText'),
      "empty-filtered-text": _vm.$t('item.listEmptyFilteredText')
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      },
      "sort-changed": _vm.sortingChanged
    },
    scopedSlots: _vm._u([{
      key: "cell(media)",
      fn: function(row) {
        return [(row.item.media[0]) ? _c('b-img-lazy', {
          attrs: {
            "width": _vm.imgSize,
            "src": row.item.media[0].url.replace(row.item.media[0].filename, ("small_" + (row.item.media[0].filename)))
          }
        }) : _c('b-img', {
          attrs: {
            "blank": "",
            "blank-color": "#ccc",
            "width": _vm.imgSize,
            "height": _vm.imgSize
          }
        })]
      }
    }, {
      key: "cell(auction_order_number)",
      fn: function(row) {
        return [(row.item.auction_order_number) ? _c('span', [_vm._v(_vm._s(row.item.auction_order_number))]) : _c('span', [_c('i', [_vm._v("-")])])]
      }
    }, {
      key: "cell(auction.abbreviation)",
      fn: function(row) {
        return [(row.item.auction.abbreviation) ? _c('span', [_vm._v(_vm._s(row.item.auction.abbreviation))]) : _c('span', [_c('i', [_vm._v("Voeg afk. toe")])])]
      }
    }, {
      key: "cell(number)",
      fn: function(row) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(row.item.seller.code) + "-" + _vm._s(row.item.number) + "\n\t\t\t\t\t")]
      }
    }, {
      key: "cell(category)",
      fn: function(row) {
        return [(row.item.category) ? _c('span', [_vm._v(_vm._s(row.item.category.slug))]) : _vm._e()]
      }
    }, {
      key: "cell(title)",
      fn: function(row) {
        return [_c('strong', [_vm._v(_vm._s(row.item.title))]), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(row.item.description))])]
      }
    }, {
      key: "cell(price)",
      fn: function(row) {
        return [(row.item.bid) ? _c('div', [_vm._v("\n\t\t\t\t\t\t\t€" + _vm._s(Math.round(row.item.bid.price)) + ",-\n\t\t\t\t\t\t")]) : _c('div', [_c('i', [_vm._v("-")])])]
      }
    }, {
      key: "cell(actions)",
      fn: function(row) {
        return [_c('b-button-group', {
          staticClass: "pull-right"
        }, [_c('b-btn', {
          attrs: {
            "variant": "outline-primary",
            "to": {
              name: 'item',
              params: {
                itemId: row.item.id,
                auctionId: row.item.auction_id
              }
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-fw fa-eye"
        })]), _vm._v(" "), _c('b-btn', {
          attrs: {
            "variant": "outline-primary",
            "to": {
              name: 'itemEdit',
              params: {
                itemId: row.item.id,
                auctionId: row.item.auction_id
              }
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-fw fa-edit"
        })])], 1)]
      }
    }, {
      key: "cell(target_price_1)",
      fn: function(row) {
        return [(row.item.target_price_1) ? _c('span', [_vm._v(_vm._s(Math.round(row.item.target_price_1)))]) : _vm._e(), _vm._v(" "), (row.item.target_price_2) ? _c('span', [(row.item.target_price_1) ? _c('span', [_vm._v("-")]) : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(Math.round(row.item.target_price_2)) + "\n\t\t\t\t\t\t")]) : _vm._e()]
      }
    }], null, false, 3379601938)
  }) : _vm._e()], 1)]), _vm._v(" "), _c('b-pagination-nav', {
    staticClass: "pull-right",
    attrs: {
      "link-gen": _vm.linkGen,
      "number-of-pages": _vm.items.last_page,
      "value": _vm.items.current_page,
      "use-router": ""
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3793a732"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Item/ItemList.vue
// module id = 1294
// module chunks = 1